import * as Yup from 'yup'

import type { FormValues } from './SelectNewDefaultPaymentMethod.types'

export const validationSchema = Yup.object().shape({
  defaultPaymentMethodId: Yup.string().when('choice', {
    is: (choice: FormValues['choice']) => choice === 'select-new-default',
    then: Yup.string().required(),
  }),
})
